
export const PricingTiers = [
  {
    name: "Starter",
    price: "Free",
    description: "Perfect for individual coaches getting started",
    features: [
      "Basic drill creation tools",
      "5 drills per month",
      "Community access",
      "Limited basic analytics",
      "2D drill preview only (no download)",
      "No copy and paste functionality",
      "7-day trial of Pro features",
    ],
    buttonText: "Get Started",
    popular: false,
    priceId: null,
  },
  {
    name: "Pro",
    price: "$29",
    period: "/month",
    description: "Ideal for professional coaches and small academies",
    features: [
      "Advanced drill creation tools",
      "Unlimited drills",
      "Priority support",
      "Advanced AI analytics",
      "3D drill simulations",
      "Custom branding",
      "Export and share functionality",
      "Team collaboration",
    ],
    buttonText: "Start Pro Trial",
    popular: true,
    priceId: "price_1QjonTH1B3DZJBD9HzD3RBYZ",
  },
  {
    name: "Enterprise",
    price: "$99",
    period: "/month",
    description: "For large academies and football organizations",
    features: [
      "All Pro features",
      "Team analytics dashboard",
      "Coach collaboration platform",
      "Custom AI reports",
      "Dedicated account manager",
      "Custom integrations",
      "API access",
      "Bulk user management",
      "Advanced security features",
      "24/7 phone support",
    ],
    buttonText: "Subscribe to Enterprise",
    popular: false,
    priceId: "price_1Qjop6H1B3DZJBD9omdGhJvg",
  },
  {
    name: "Club & Academy",
    price: "$500",
    period: "/season",
    description: "Customized solutions for clubs & academies",
    features: [
      "Team analytics dashboard",
      "Performance tracking for all players",
      "Seasonal data reports",
      "API access for integration",
      "Custom branding & white-labeling",
      "Dedicated success manager",
      "Data export capabilities",
      "Premium onboarding & training",
    ],
    buttonText: "Request Demo",
    popular: false,
    priceId: null,
    customPricing: true,
  },
];

export type PricingTier = typeof PricingTiers[number];
